<template>
  <ion-page>
    <ion-header v-if="loginStatus === 'success'" class="masterHeader">
      <ion-toolbar class="toolbar-header">
        <ion-buttons slot="start">
          <ion-menu-button color="dark" id="mobile-menu-button"></ion-menu-button>
        </ion-buttons>
        <ion-title class="toolbar-header-title">
          {{ pageTitle }}
          <!-- not needed as of now (need to remove full code related to this in next release) -->
          <!-- <div v-if="thisRouterPath === '/page-inbox'" class="refresh-container">
            <ion-spinner v-if="refreshLoading" name="lines-small" class="refresh-spinner"></ion-spinner>
            <VIcon v-else name="refresh-line" class="refresh-icon" @click="refreshPage" title="Refresh"></VIcon>
            <span v-if="refreshLoading" class="loading-text">Loading...</span>
          </div> -->
        </ion-title>

        <!-- Status Dropdown - Only for page-inbox -->
        <div v-if="thisRouterPath === '/page-inbox' && (isAdmin === false || isAdmin === null)" class="status-dropdown-container" slot="end">
          <!-- Current status display with dot -->
          <div class="current-status-display">
            <div :class="['status-dot', userStatus]"></div>
            <span class="status-text">{{ getStatusText(userStatus) }}</span>

            <VIcon name="chevron-down-line" class="agent-online-status-down-icon"></VIcon>
          </div>
          
          <!-- Hidden select for functionality -->
          <ion-select 
            v-model="userStatus" 
            interface="popover" 
            class="status-select-styled"
            :disabled="statusUpdateLoading"
            @ionChange="onStatusChange"
          >
            <ion-select-option value="online">Online</ion-select-option>
            <ion-select-option value="offline">Offline</ion-select-option>
          </ion-select>
          
          <!-- Show loading indicator when updating -->
          <ion-spinner v-if="statusUpdateLoading" name="lines-small" class="status-loader"></ion-spinner>
        </div>

        <!-- <div id="restart-intro" @click="restartIntro" class="start-intro" slot="end">
          <VIcon name="info-line" class="start-intro-icon"></VIcon>
        </div> -->
        <div v-if="!IS_LIVE" @click="reportIssue" class="start-intro" slot="end">
          <VIcon name="error-star-line" class="start-intro-icon"></VIcon>
        </div>
        <!-- <ion-thumbnail slot="end" class="ion-hide-md-down toolbar-img">
          <img :src="isDarkMode ? require('/src/resources/images/flash-power-dark.svg') : require('/src/resources/images/flash-power.svg')" />
        </ion-thumbnail> -->
        <ion-thumbnail slot="end" class="ion-hide-md-down toolbar-img">
          <img :src="isDarkMode ? require('/src/resources/images/vonage-logo-dark.svg') : require('/src/resources/images/Vonage_logo.svg')" />
        </ion-thumbnail>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <slot> </slot>
    </ion-content>
    <audio id="customerUnReadMessagesAudio" style="height: 0px; width: 0px; opacity: 0; position: fixed; bottom: -50px;">
      <source :src="newMessageSound" type="audio/mpeg">
      <source :src="newMessageSoundwav" type="aaudio/wav">
    </audio>
  </ion-page>
</template>
<script>
import { IonPage,IonHeader,IonContent,IonToolbar,IonTitle,IonMenuButton,IonButtons, IonSelect, IonSelectOption, IonSpinner } from "@ionic/vue";
import newMessageSound from '@/resources/images/page-inbox-new-message.mp3';
import newMessageSoundwav from '@/resources/images/page-inbox-new-message.wav';
import { useChatStore } from '@/stores/chat';
import { useUIStore } from '@/stores/ui';
import { useAuthStore } from '@/stores/auth';
import { environment } from '@/shared/env.js';
import apiInterceptor from '@/shared/apiInterceptor';
import { queryClient } from '@/shared/queryClient';
import { useRoleDetails } from '@/composables/useRoleDetails';

export default {
  components: {
    IonPage,IonHeader,IonContent,IonToolbar,IonTitle,IonMenuButton,IonButtons,IonSelect,IonSelectOption,IonSpinner
  },
  props: ["pageTitle"],
  setup() {
    const chatStore = useChatStore();
    const { roleDetails } = useRoleDetails();
    return { chatStore, roleDetails };
  },
  computed: {
    IS_LIVE() { return !window.location.hostname.includes('localhost') && !window.location.hostname.includes('staging'); },
    isAdmin() { return useAuthStore().isAdmin; },
    loginStatus() { return useAuthStore().getLoginStatus; },
    isDarkMode() { return useUIStore().isDarkMode; },
    thisRouterPath() {
      return this.$route.path;
    },
    userStatus() {
      // Get status directly from roleDetails
      return this.roleDetails?.is_online ? 'online' : 'offline';
    }
  },
  data(){
    return {
      newMessageSound,
      newMessageSoundwav,
      statusUpdateLoading: false,
      refreshLoading: false,
      officeHoursEventAdded: false
    }
  },
  mounted() {
    this.addOfficeHoursEventListener();
  },
  beforeUnmount() {
    if (this._officeHoursHandler) {
      document.removeEventListener('livechat_online_status', this._officeHoursHandler);
    }
  },
  methods: {
    addOfficeHoursEventListener() {
      // Listen for office-hours online-status changes via the store's DOM
      // CustomEvent (provider-agnostic: works for both Pusher and Centrifugo).
      // Previously this bound directly to the Pusher channel object, which the
      // Centrifugo client does not expose.
      if (this.officeHoursEventAdded) return;
      this._officeHoursHandler = (e) => {
        this.handleOfficeHoursStatusChange(e.detail);
      };
      document.addEventListener('livechat_online_status', this._officeHoursHandler);
      this.officeHoursEventAdded = true;
    },
    handleOfficeHoursStatusChange(data) {
      // Update userStatus based on office hours data
      if (typeof data.is_online !== 'undefined') {
        // Update roleDetails in store/local state to reflect the new status
        this.updateUserStatusFromPusher();

        // Show toast notification
        /* useUIStore().updateToast({
          open: true,
          message: `Office hours turned ${data.is_online ? 'on' : 'off'}. Status changed to ${this.getStatusText(this.userStatus)}`,
          type: "info"
        }); */
      }
    },
    async updateUserStatusFromPusher() {
      try {
        // Just refetch the role-details query so the reactive `userStatus` computed
        // picks up the new is_online value. Do NOT call checkToken() here — it
        // disconnects/reinitializes the Pusher connection, which tears down the very
        // channel that's dispatching this event and drops the 'livechat_online_status'
        // binding (only re-added once in mounted()), breaking subsequent status updates.
        await queryClient.refetchQueries({ queryKey: ['role-details'] });
      } catch (error) {
        console.error("Exception updating user status from pusher: ", error);
      }
    },
    /* restartIntro() {
      document.dispatchEvent(new CustomEvent("restartIntro"));
    } */
    reportIssue() {
      document.dispatchEvent(new CustomEvent("openReportIssue"));
    },
    async onStatusChange(event) {
      const newStatus = event.detail.value;
      
      try {
        await this.updateUserStatusAPI(newStatus);
        
        // Show success toast
        useUIStore().updateToast({
          open: true,
          message: `Status changed to ${this.getStatusText(newStatus)}`,
          type: "success"
        });
        
      } catch (error) {
        useUIStore().updateToast({
          open: true,
          message: error.message || "Failed to update status. Please try again.",
          type: "danger"
        });
      }
    },
    async updateUserStatusAPI(status) {
      try {
        this.statusUpdateLoading = true;
        
        const reqBody = {
          is_online: status === 'online'
        };
        
        await apiInterceptor.patch(environment('VUE_APP_API_URL') + "roles/v1/role-details/", reqBody);
        
        // Clear cached role data to fetch updated info
        await queryClient.refetchQueries({ queryKey: ['role-details'] });
        await useAuthStore().checkToken();
        
      } catch (error) {
        console.error("Exception: ", error);
        throw new Error(error.message || "Something went wrong while updating status");
      } finally {
        this.statusUpdateLoading = false;
      }
    },
    getStatusText(status) {
      const statusMap = {
        'online': 'Online',
        'offline': 'Offline'
      };
      return statusMap[status] || 'Online';
    },
    refreshPage() {
      // Set loading state
      this.refreshLoading = true;
      
      // Dispatch custom event for LiveChatHome to listen
      const refreshEvent = new CustomEvent("refresh-page", {
        detail: { source: 'header_refresh_icon' }
      });
      document.dispatchEvent(refreshEvent);
      
      // Listen for refresh completion
      const refreshCompleteHandler = () => {
        this.refreshLoading = false;
        document.removeEventListener("refresh-page-complete", refreshCompleteHandler);
      };
      document.addEventListener("refresh-page-complete", refreshCompleteHandler);
      
      // Fallback timeout to reset loading state after 5 seconds
      setTimeout(() => {
        this.refreshLoading = false;
      }, 5000);
    }
  }
};
</script>

<style scoped>
.toolbar-header{
  color: var(--white);
}
.toolbar-header-title{
  color: var(--black);
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 28px;
}
.toolbar-img{
  max-width: 100%;
  width: auto;
  height: 30px;
  margin-top: 5px;
  padding-left: 15px;
  padding-right: 15px;
}
.start-intro {
  margin: 0 10px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.start-intro-icon {
  font-size: 1.5rem;
  color: var(--black);
}
ion-header.masterHeader{
  box-shadow: none;
  border-bottom: 1px solid var(--background-primary);
}

.status-dropdown-container {
  display: flex;
  align-items: center;
  margin-right: 15px;
  position: relative;
}

.current-status-display {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 8px 12px;
  background: transparent;
  border-radius: 25px;
  border: 1px solid rgba(0, 0, 0, 0.13);
  cursor: pointer;
  pointer-events: none; /* Let the select handle clicks */
}

.status-text {
  font-size: 16px;
  color: var(--black);
  font-weight: 500;
}

.status-select-styled {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}

.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
}

.status-dot.online {
  background-color: #22c55e; /* Green */
}

.status-dot.offline {
  background-color: #ef4444; /* Red */
}

.status-loader {
  width: 16px;
  height: 16px;
  margin-left: 8px;
}

.agent-online-status-down-icon {
  font-size: 1.1rem;
  color: var(--black);
}

.refresh-icon {
  font-size: 1rem;
  color: var(--white);
  margin-left: 10px;
  cursor: pointer;
  -webkit-border-radius: 50%;
  border-radius: 50%;
  background-color: var(--ion-color-primary);
  padding: 3px;
  line-height: 1.2;
}

.refresh-container {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  margin-left: 10px;
}

.refresh-spinner {
  width: 16px;
  height: 16px;
  color: var(--ion-color-primary);
}

.loading-text {
  font-size: 12px;
  color: var(--black);
  font-weight: 400;
}

@media only screen and (max-width: 1024px){
  .current-status .status-text {
    display: none; /* Hide text on smaller screens, keep only dot */
  }
}

@media only screen and (max-width: 760px){
  .toolbar-header-title{
    font-size: 18px;
    padding: 0px;
  }
  
  .status-dropdown-container {
    /* display: none; */
  }
}
</style>